import { classNames } from '@wix/answers-lib';
export const namespaceClassName = 'aul';
export const namespacedClassnames = (...args) => classNames(namespaceClassName, args);
